export default __webpack_public_path__ + "static/media/icon-ds.8c921c6361cb0d38b0c938e1cb84f880.svg";